import {none, Opt} from 'ts-opt';

import {MilkabilityDetail} from 'api/gen/MilkabilityDetail';
import {PagedModelMilkability} from 'api/gen/PagedModelMilkability';

import {MilkabilityLoadingId} from '../types/milkability-loading-id';

/** Redux state stored for the milkability module. */
export interface MilkabilityState {
    /** Paginated milkability overview rows for the connected table. */
    pageMilkability: Opt<PagedModelMilkability>;
    /** Reports created during the current create/edit session. */
    createdMilkabilityReports: Array<MilkabilityDetail>;
    /** Currently edited milkability report id, when editing an existing record. */
    editingMilkabilityReportId?: number;
    /** Active loading-state identifiers for milkability async workflows. */
    loading: Array<MilkabilityLoadingId>;
}

/** Default milkability state snapshot. */
export const initialMilkabilityState: MilkabilityState = {
    pageMilkability: none,
    createdMilkabilityReports: [],
    editingMilkabilityReportId: undefined,
    loading: [],
};
